import { l10n } from '@ott/l10n';
import isEmpty from 'lodash/isEmpty';
import validate from '@ott/utility-form-validate';
import rules from '@ott/utility-form-validate-rules';

function hasValidationErrors(errors) {
  const { flights, ...restErrors } = errors;

  if (!isEmpty(restErrors)) {
    return true;
  }

  return flights.some((flight) => !isEmpty(flight));
}

const validateFlight = validate({
  from: [
    {
      msg: l10n('flightsSearchForm.filters.chooseDepartureCity'),
      validate(field) {
        const { code } = field;

        return rules.isRequired(code);
      },
    },
  ],
  to: [
    {
      msg: l10n('flightsSearchForm.filters.chooseArrivalCity'),
      validate(field) {
        const { code } = field;

        return rules.isRequired(code);
      },
    },
  ],
  dates: [
    {
      msg: l10n('flightsSearchForm.filters.chooseDates'),
      validate(field) {
        const { toDate } = field;

        return rules.isRequired(toDate);
      },
    },
  ],
});

const validateForm = (formFields) => {
  const { flights } = formFields;

  const result = {
    flights: flights.map(validateFlight),
  };

  return result;
};

const validateSync = (formFields) => {
  const { flights = [] } = formFields;

  const validationResult = {
    flights: flights.map(validateFlight),
  };

  return validationResult;
};

export default {
  hasValidationErrors,
  validateForm,
  validateSync,
};
